/* Fig & Bloom — Estimated Flower Journey v1.1 kilometres PDP behaviour */
(function () {
  "use strict";

  var STUDIOS = {
    melbourne_fairfield: "Melbourne",
    sydney_camperdown: "Sydney",
    brisbane_bowen_hills: "Brisbane"
  };

  /* Which studio prepares an order for a given state. Mirrors the operational
     grouping already stated on the city pages (snippets/city-seo-content.liquid:
     Sydney for Canberra/Central Coast/Newcastle/Wollongong, Brisbane for the Gold
     Coast and Sunshine Coast, Melbourne for Adelaide and regional Victoria), which
     is where the "Adelaide is served from Melbourne" fact comes from.
     WA, TAS and NT are absent deliberately: no delivery location covers a 6xxx,
     7xxx or 08xx/09xx postcode, so there is no studio to name and the component
     keeps its neutral state rather than asserting one. If operations ever
     reassign a state, change it here and in city-seo-content.liquid together. */
  var STUDIO_BY_STATE = {
    vic: "melbourne_fairfield",
    sa: "melbourne_fairfield",
    nsw: "sydney_camperdown",
    act: "sydney_camperdown",
    qld: "brisbane_bowen_hills"
  };

  function cookie(name) {
    var prefix = name + "=";
    var parts = document.cookie.split(";");
    for (var i = 0; i < parts.length; i += 1) {
      var value = parts[i].trim();
      if (value.indexOf(prefix) === 0) {
        try { return decodeURIComponent(value.slice(prefix.length)); }
        catch (e) { return value.slice(prefix.length); }
      }
    }
    return "";
  }

  /* Australia Post state ranges. The delivery POSTCODE is the primary signal, not
     the deliveryState cookie: every flow that stores a delivery location writes
     deliveryPostcode, but the state is optional (fb-suburb-grid.js seeds a city or
     suburb page's cookies with `if (state)`, and city metaobjects carry no state
     field), so a postcode-only visitor has no state to read. */
  function stateFromPostcode(postcode) {
    var pc = parseInt(String(postcode).replace(/\D/g, ""), 10);
    if (!pc) return "";
    if (pc >= 200 && pc <= 299) return "act";
    if (pc >= 800 && pc <= 999) return "nt";
    if (pc >= 1000 && pc <= 2599) return "nsw";
    if (pc >= 2600 && pc <= 2618) return "act";
    if (pc >= 2619 && pc <= 2899) return "nsw";
    if (pc >= 2900 && pc <= 2920) return "act";
    if (pc >= 2921 && pc <= 2999) return "nsw";
    if (pc >= 3000 && pc <= 3999) return "vic";
    if (pc >= 4000 && pc <= 4999) return "qld";
    if (pc >= 5000 && pc <= 5999) return "sa";
    if (pc >= 6000 && pc <= 6999) return "wa";
    if (pc >= 7000 && pc <= 7999) return "tas";
    if (pc >= 8000 && pc <= 8999) return "vic";
    if (pc >= 9000 && pc <= 9999) return "qld";
    return "";
  }

  function stateFromCookie() {
    var state = cookie("deliveryState").toLowerCase().replace(/\./g, "").trim();
    if (state === "vic" || state.indexOf("victoria") !== -1) return "vic";
    if (state === "nsw" || state.indexOf("new south wales") !== -1) return "nsw";
    if (state === "qld" || state.indexOf("queensland") !== -1) return "qld";
    if (state === "act" || state.indexOf("capital territory") !== -1) return "act";
    if (state === "sa" || state.indexOf("south australia") !== -1) return "sa";
    return "";
  }

  /* Only the app resolver knows whether we actually deliver to a postcode, and it
     says so with the exact string "Unknown Location" — a truthy value, which is why
     it is compared rather than tested. Anything else (a real location name, or a
     null from a page with no app config) leaves the studio mapping to decide. */
  function outOfNetwork(postcode) {
    if (!postcode || typeof window.findPostcodeLocation !== "function") return false;
    try {
      return String(window.findPostcodeLocation(postcode)).toLowerCase() === "unknown location";
    } catch (e) {
      return false;
    }
  }

  function studioFromDelivery() {
    var postcode = cookie("deliveryPostcode").trim();
    var studio = STUDIO_BY_STATE[stateFromPostcode(postcode) || stateFromCookie()];
    if (!studio || outOfNetwork(postcode)) return null;
    return studio;
  }

  function selectedVariantId(root) {
    var formInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (formInput && formInput.value) return String(formInput.value);
    var urlVariant = new URL(window.location.href).searchParams.get("variant");
    return String(urlVariant || root.getAttribute("data-initial-variant-id") || "");
  }

  function customerState() {
    return document.documentElement.getAttribute("data-sp-state") === "member" ? "member" : "guest";
  }

  function update(root) {
    root.hidden = true;
    var store = window.FB_FLOWER_JOURNEY_DATA;
    if (!store || !store.products) return;
    var product = store.products[root.getAttribute("data-product-handle")];
    if (!product) return;

    var variantId = selectedVariantId(root);
    var variant = product.variants[variantId];
    if (!variant) return;
    var studios = variant[customerState()];
    function valid(metric) {
      return metric && typeof metric.display === "string" &&
        /^(About|Under) [\d,]+ km$/.test(metric.display) &&
        Number(metric.display.replace(/[^0-9]/g, "")) > 0 &&
        Number.isFinite(metric.average_km) && metric.average_km > 0 &&
        Number.isFinite(metric.stem_count) && metric.stem_count > 0;
    }
    if (!studios || !Object.keys(studios).some(function (id) { return valid(studios[id]); })) return;

    var studioId = studioFromDelivery();
    var distance = root.querySelector("[data-fj-distance]");
    var label = root.querySelector("[data-fj-label]");
    var destination = root.querySelector("[data-fj-destination]");
    if (studioId && !valid(studios[studioId])) return;
    if (studioId) {
      distance.textContent = studios[studioId].display + " per stem";
      label.textContent = "estimated straight-line distance from origin";
      destination.textContent = "From known origin to the studio that makes your order; delivery to you is excluded.";
    } else {
      distance.textContent = "Add delivery details";
      label.textContent = "to see the estimated straight-line distance from origin per stem";
      destination.textContent = "We’ll match the estimate to the studio preparing your bouquet.";
    }
    root.hidden = false;
  }

  function init(root) {
    var lastCookies = "";
    var refresh = function () { update(root); };

    document.addEventListener("change", function (event) {
      if (event.target && (event.target.name === "id" || event.target.closest("variant-radios, variant-selects"))) {
        window.setTimeout(refresh, 0);
      }
    });

    var observer = new MutationObserver(refresh);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-sp-state"] });
    var locationText = document.getElementById("selectedLocationText");
    if (locationText) observer.observe(locationText, { childList: true, subtree: true });

    window.setInterval(function () {
      if (document.hidden) return;
      var next = cookie("deliveryState") + "|" + cookie("deliveryPostcode");
      if (next !== lastCookies) {
        lastCookies = next;
        refresh();
      }
    }, 1200);

    refresh();
  }

  function start() {
    document.querySelectorAll("[data-fj-root]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
